import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import * as Icons from 'lucide-react';
import { db, auth } from '../firebase/config';
import { createUserWithEmailAndPassword, updateProfile, sendEmailVerification } from 'firebase/auth';
import { doc, setDoc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { toast } from 'react-hot-toast';

// Előnyklub logo inline SVG
const ElonyklubLogo = () => (
  <svg width="162" height="30" viewBox="0 0 324 59" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.3025 47V5.784H33.2625V16.92H15.7905V20.632H30.8305V32.152H15.7905V35.864H33.2625V47H0.3025ZM47.9625 47.64C43.4825 47.64 40.3252 46.744 38.4905 44.952C36.6985 43.16 35.8025 40.3867 35.8025 36.632V3.864H51.2905V34.584C51.2905 35.3947 51.4398 35.992 51.7385 36.376C52.0798 36.76 52.6772 36.952 53.5305 36.952C54.7252 36.952 55.7918 36.76 56.7305 36.376V45.976C55.4078 46.5307 54.1492 46.936 52.9545 47.192C51.7598 47.4907 50.0958 47.64 47.9625 47.64ZM60.6465 13.592L66.7265 0.599998H79.9105L72.6145 13.592H60.6465ZM77.9265 13.592L84.0065 0.599998H97.1905L89.8945 13.592H77.9265ZM77.0945 47.64C70.6518 47.64 65.8518 46.3173 62.6945 43.672C59.5798 41.0267 58.0225 37.08 58.0225 31.832C58.0225 26.584 59.5798 22.6373 62.6945 19.992C65.8518 17.3467 70.6518 16.024 77.0945 16.024C89.8518 16.024 96.2305 21.2933 96.2305 31.832C96.2305 42.3707 89.8518 47.64 77.0945 47.64ZM77.0945 36.568C78.2038 36.568 79.0358 36.2267 79.5905 35.544C80.1452 34.8613 80.4225 33.624 80.4225 31.832C80.4225 30.04 80.1452 28.8027 79.5905 28.12C79.0358 27.4373 78.2038 27.096 77.0945 27.096C76.0278 27.096 75.2172 27.4373 74.6625 28.12C74.1078 28.8027 73.8305 30.04 73.8305 31.832C73.8305 33.624 74.1078 34.8613 74.6625 35.544C75.2172 36.2267 76.0278 36.568 77.0945 36.568ZM99.4275 47V16.664H113.956L114.276 18.392C115.385 17.7947 116.878 17.2613 118.756 16.792C120.676 16.28 122.745 16.024 124.964 16.024C128.59 16.024 131.214 16.984 132.836 18.904C134.5 20.7813 135.332 23.64 135.332 27.48V47H119.844V29.464C119.844 28.0987 119.14 27.416 117.732 27.416C117.305 27.416 116.793 27.544 116.196 27.8C115.641 28.056 115.214 28.3547 114.916 28.696V47H99.4275ZM150.281 58.264C148.19 58.264 146.484 58.1573 145.161 57.944C143.881 57.7307 142.58 57.3467 141.257 56.792V46.936C142.494 47.3627 143.774 47.576 145.097 47.576C146.377 47.576 147.444 47.4693 148.297 47.256C149.15 47.0853 149.876 46.68 150.473 46.04L136.585 16.664H152.777L158.089 31.768L163.145 16.664H179.273L168.841 43.352C167.006 48.0027 164.617 51.6507 161.673 54.296C158.729 56.9413 154.932 58.264 150.281 58.264ZM181.178 47V5.784H196.666V17.304L205.69 5.784H223.162L209.082 22.872L224.442 47H208.058L199.61 32.664L196.666 36.248V47H181.178ZM237.213 47.64C232.733 47.64 229.575 46.744 227.741 44.952C225.949 43.16 225.053 40.3867 225.053 36.632V3.864H240.541V34.584C240.541 35.3947 240.69 35.992 240.989 36.376C241.33 36.76 241.927 36.952 242.781 36.952C243.975 36.952 245.042 36.76 245.981 36.376V45.976C244.658 46.5307 243.399 46.936 242.205 47.192C241.01 47.4907 239.346 47.64 237.213 47.64ZM257.744 47.64C254.33 47.64 251.621 46.6373 249.616 44.632C247.61 42.6267 246.608 39.704 246.608 35.864V16.664H262.096V34.2C262.096 35.5653 262.8 36.248 264.208 36.248C264.677 36.248 265.189 36.12 265.744 35.864C266.298 35.608 266.725 35.3093 267.024 34.968V16.664H282.512V47H267.984L267.664 45.272C266.554 45.9547 265.125 46.5307 263.376 47C261.669 47.4267 259.792 47.64 257.744 47.64ZM309.646 47.64C307.811 47.64 306.211 47.4053 304.846 46.936C303.481 46.4667 302.243 45.8267 301.134 45.016L300.43 47H286.99V3.864H302.478V17.176C303.289 16.8347 304.313 16.5573 305.55 16.344C306.787 16.1307 307.961 16.024 309.07 16.024C313.763 16.024 317.411 17.1973 320.014 19.544C322.659 21.8907 323.982 25.9013 323.982 31.576C323.982 36.9947 322.659 41.0267 320.014 43.672C317.411 46.3173 313.955 47.64 309.646 47.64ZM305.166 36.568C306.105 36.568 306.83 36.248 307.342 35.608C307.897 34.9253 308.174 33.6667 308.174 31.832C308.174 29.9973 307.897 28.76 307.342 28.12C306.83 27.4373 306.105 27.096 305.166 27.096C304.142 27.096 303.246 27.416 302.478 28.056V35.608C302.905 35.9067 303.31 36.1413 303.694 36.312C304.121 36.4827 304.611 36.568 305.166 36.568Z" fill="white"/>
  </svg>
);

export default function Register() {
  const { referralCode } = useParams(); // pl: /register/johndoe
  const navigate = useNavigate();
  const { t, i18n, languages, defaultLanguage } = useTranslation();
  
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
  });
  
  const [referrer, setReferrer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Referrer ellenőrzése
  useEffect(() => {
    const verifyReferrer = async () => {
      try {
        if (!referralCode) {
          setError('invalid_referral');
          return;
        }

        // Először keressük a users kollekcióban
        const usersRef = collection(db, 'users');
        const usersQuery = query(usersRef, where('username', '==', referralCode));
        const usersSnapshot = await getDocs(usersQuery);
        
        // Ha nem találtuk a users-ben, keressük a customers-ben
        if (usersSnapshot.empty) {
          const customersRef = collection(db, 'customers');
          const customersQuery = query(customersRef, where('username', '==', referralCode));
          const customersSnapshot = await getDocs(customersQuery);
          
          if (customersSnapshot.empty) {
            setError('invalid_referral');
            return;
          }
          
          const referrerDoc = customersSnapshot.docs[0];
          const referrerData = referrerDoc.data();
          setReferrer({
            ...referrerData,
            id: referrerDoc.id,
            docId: referrerDoc.id
          });
        } else {
          const referrerDoc = usersSnapshot.docs[0];
          const referrerData = referrerDoc.data();
          setReferrer({
            ...referrerData,
            id: referrerDoc.id,
            docId: referrerDoc.id
          });
        }

        setLoading(false);
      } catch (err) {
        setError('invalid_referral');
        console.error(err);
      }
    };

    verifyReferrer();
  }, [referralCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // Validációk
    if (!formData.firstName.trim() || !formData.lastName.trim()) {
      setError(t('register.errors.nameRequired'));
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError(t('register.errors.passwordMismatch'));
      return;
    }

    if (formData.password.length < 6) {
      setError(t('register.errors.weakPassword'));
      return;
    }

    try {
      // Ellenőrizzük, hogy a felhasználónév foglalt-e
      const usernameQuery = query(
        collection(db, 'users'),
        where('username', '==', formData.username)
      );
      const usernameSnapshot = await getDocs(usernameQuery);
      
      if (!usernameSnapshot.empty) {
        setError(t('register.errors.usernameTaken'));
        return;
      }

      // Felhasználó létrehozása Auth-ban
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      // Felhasználó profil frissítése
      await updateProfile(userCredential.user, {
        displayName: `${formData.firstName} ${formData.lastName}`,
        // photoURL: lehet később hozzáadni
      });

      // Email verifikáció küldése
      await sendEmailVerification(userCredential.user);

      // Ellenőrizzük, hogy van-e érvényes referrer
      if (!referrer?.docId) {
        throw new Error('Invalid referrer');
      }

      // Customer adatok mentése Firestore-ba
      await setDoc(doc(db, 'customers', userCredential.user.uid), {
        customerId: userCredential.user.uid,
        name: `${formData.lastName} ${formData.firstName}`,
        primaryContact: {
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phone: '',
          newsletter: false,
          position: ''
        },
        secondaryContact: {
          email: '',
          firstName: '',
          lastName: '',
          newsletter: false,
          phone: '',
          position: ''
        },
        address: {
          city: '',
          country: 'Magyarország',
          countryCode: 'HU',
          fullAddress: '',
          zipCode: ''
        },
        notes: {
          internalNote: '',
          invoiceNote: ''
        },
        payment: {
          defaultDueDate: 0,
          defaultPaymentMethod: 'átutalás'
        },
        taxDetails: {
          euTaxNumber: '',
          groupTaxNumber: '',
          registrationNumber: '',
          taxNumber: '',
          thirdCountryTaxId: ''
        },
        status: 'Új partner',
        createdAt: new Date(),
        updatedAt: new Date(),
        inviteCode: referralCode, // Mentsük el a meghívó kódot
        referrerId: referrer.docId, // Mentsük el a meghívó ID-ját
        authProfile: {
          displayName: `${formData.firstName} ${formData.lastName}`,
          email: formData.email,
          emailVerified: false,
          username: formData.username
        }
      });

      // Sikeres regisztráció után üzenet és átirányítás
      toast.success(t('register.verificationEmailSent'));
      navigate('/customer/dashboard');
    } catch (err) {
      console.error(err);
      let errorMessage;
      switch (err.code) {
        case 'auth/email-already-in-use':
          errorMessage = t('register.errors.emailExists');
          break;
        case 'auth/operation-not-allowed':
          errorMessage = t('register.errors.authDisabled');
          break;
        case 'auth/weak-password':
          errorMessage = t('register.errors.weakPassword');
          break;
        default:
          errorMessage = t('register.errors.registrationFailed');
      }
      setError(errorMessage);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-gray-100 text-center">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <div className="h-16 w-auto px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-xl flex items-center justify-center">
              <ElonyklubLogo />
            </div>
          </div>
          
          <div className="flex flex-col items-center gap-4">
            <Icons.AlertCircle className="h-12 w-12 text-red-500" />
            <h2 className="text-xl font-semibold text-gray-900">
              {t('register.errors.invalidReferral')}
            </h2>
            <p className="text-sm text-gray-500">
              {t('register.verifyingReferral')}
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors duration-200"
            >
              <Icons.ArrowLeft className="w-4 h-4" />
              {t('common.back')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    if (error === 'invalid_referral') {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-gray-100 text-center">
            {/* Logo */}
            <div className="flex justify-center mb-8">
              <div className="h-16 w-auto px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-xl flex items-center justify-center">
                <ElonyklubLogo />
              </div>
            </div>
            
            <Icons.AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {t('register.errors.invalidReferral')}
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              {t('register.errors.checkReferral')}
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors duration-200"
            >
              <Icons.ArrowLeft className="w-4 h-4" />
              {t('common.back')}
            </button>
          </div>
        </div>
      );
    }
    
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Icons.AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-lg font-medium text-gray-900">{error}</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-12 px-4 sm:px-6 lg:px-8">
      {/* Language Switcher */}
      <div className="fixed top-4 right-4 z-50">
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            {languages?.find(lang => lang.code === (i18n?.language || defaultLanguage))?.flag || '🌐'}
            <Icons.ChevronDown className="w-4 h-4" />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-40 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                {languages?.map((language) => (
                  <Menu.Item key={language.code}>
                    {({ active }) => (
                      <button
                        onClick={() => i18n?.changeLanguage?.(language.code)}
                        className={`${
                          active ? 'bg-gray-50 text-gray-900' : 'text-gray-700'
                        } flex w-full items-center gap-2 px-4 py-2 text-sm`}
                      >
                        <span>{language.flag}</span>
                        <span>{language.name}</span>
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>

      {/* Háttér dekoráció */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute -top-1/2 -right-1/2 w-96 h-96 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 opacity-50 blur-3xl" />
        <div className="absolute -bottom-1/2 -left-1/2 w-96 h-96 rounded-full bg-gradient-to-tr from-blue-100 to-indigo-100 opacity-50 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-md w-full space-y-8">
        {/* Logo */}
        <div className="flex justify-center">
          <div className="h-16 w-auto px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-xl flex items-center justify-center">
            <ElonyklubLogo />
          </div>
        </div>

        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
            {t('register.title')}
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500">
            <Icons.UserPlus className="h-5 w-5 text-blue-500" />
            {t('register.referredBy')} 
            <span className="font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-full border border-blue-100">
              {referrer.username}
            </span>
          </div>
        </div>

        <form className="mt-8 space-y-6 bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-gray-100" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm space-y-4">
            <div>
              <label htmlFor="firstName" className="sr-only">
                {t('register.form.firstName')}
              </label>
              <input
                id="firstName"
                name="firstName"
                type="text"
                required
                className="appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder={t('register.form.firstName')}
                value={formData.firstName}
                onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="lastName" className="sr-only">
                {t('register.form.lastName')}
              </label>
              <input
                id="lastName"
                name="lastName"
                type="text"
                required
                className="appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder={t('register.form.lastName')}
                value={formData.lastName}
                onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="username" className="sr-only">
                {t('register.form.username')}
              </label>
              <div className="space-y-1">
                <input
                  id="username"
                  name="username"
                  type="text"
                  required
                  className="appearance-none rounded-lg relative block w-full px-4 py-3 border border-gray-200 placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 sm:text-sm"
                  placeholder={t('register.form.username')}
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                />
                <div className="flex items-center gap-1.5 text-xs text-amber-600">
                  <Icons.Info className="h-3.5 w-3.5" />
                  {t('register.form.usernameWarning')}
                </div>
              </div>
            </div>
            <div>
              <label htmlFor="email" className="sr-only">
                {t('register.form.email')}
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder={t('register.form.email')}
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                {t('register.form.password')}
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder={t('register.form.password')}
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="confirmPassword" className="sr-only">
                {t('register.form.confirmPassword')}
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                required
                className="appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder={t('register.form.confirmPassword')}
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-lg shadow-blue-500/30 transition-all duration-200"
            >
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <Icons.LogIn className="h-5 w-5 text-blue-300 group-hover:text-blue-200" />
              </span>
              {t('register.form.submit')}
            </button>
          </div>
        </form>

        {/* Footer */}
        <div className="text-center text-sm text-gray-500">
          <p className="mt-2 flex items-center justify-center gap-2">
            {t('register.secure')} 
            <Icons.Shield className="w-4 h-4 text-green-500" />
          </p>
        </div>
      </div>
    </div>
  );
}